<app-spinner-service></app-spinner-service>

<form [formGroup]="clienteForm" class="form-grid pt-2 pl-6 pr-6 pb-6" (ngSubmit)="onSubmit()">
  <fieldset class="form-block">
    <legend class="form-block-legend">Dados do Cliente</legend>
    <div class="form-row">
      <div class="form-field form-field-6">
        <label for="nomeRazaoSocial">Nome / Razão Social <span class="required">*</span></label>
        <input
          id="nomeRazaoSocial"
          type="text"
          pInputText
          formControlName="nomeRazaoSocial"
          (input)="onNomeRazaoSocialInput($event)"
          placeholder="Digite o nome ou razão social"
          [ngClass]="{'invalid-field': clienteForm.get('nomeRazaoSocial')?.invalid && clienteForm.get('nomeRazaoSocial')?.touched}" />
        <small *ngIf="clienteForm.get('nomeRazaoSocial')?.invalid && clienteForm.get('nomeRazaoSocial')?.touched" class="error-message">
          Nome / Razão Social é obrigatório.
        </small>
      </div>

      <div class="form-field form-field-3">
        <label for="tipoIdentificacaoCpfCnpj">Tipo de Documento <span class="required">*</span></label>
        <p-dropdown 
          id="tipoIdentificacaoCpfCnpj"
          [options]="identificacoesCpfCnpjs" 
          optionLabel="nome" 
          optionValue="tipo"
          formControlName="tipoIdentificacaoCpfCnpj" 
          (onChange)="onChangeidentificacaoCpfCnpj($event.value)"
          [showClear]="false" 
          placeholder="Selecione o tipo de documento"
          [ngClass]="{'invalid-field': clienteForm.get('tipoIdentificacaoCpfCnpj')?.invalid && clienteForm.get('tipoIdentificacaoCpfCnpj')?.touched}">
        </p-dropdown>
        <small *ngIf="clienteForm.get('tipoIdentificacaoCpfCnpj')?.invalid && clienteForm.get('tipoIdentificacaoCpfCnpj')?.touched" class="error-message">
          Tipo de documento é obrigatório.
        </small>
      </div>

      <div class="form-field form-field-3" *ngIf="showDocumentNumber">
        <label for="cpfCnpj">{{ cpfCnpjLabel }} <span class="required">*</span></label>
        <input
          id="cpfCnpj"
          type="text"
          pInputText
          formControlName="cpfCnpj"
          [disabled]="!cpfCnpjEnabled"
          (input)="onCpfCnpjInput($event)"
          [mask]="getMask()"
          [attr.maxlength]="maxCpfCnpjLength"
          placeholder="Digite o {{ cpfCnpjLabel.toLowerCase() }}"
          [ngClass]="{'invalid-field': clienteForm.get('cpfCnpj')?.invalid && clienteForm.get('cpfCnpj')?.touched}" />
        <small class="field-hint" *ngIf="identificacaoCpfCnpj === IdentificacaoCpfCnpjEnum.Cnpj">Exemplo: {{ exemploCnpj }}</small>
        <small *ngIf="clienteForm.get('cpfCnpj')?.invalid && clienteForm.get('cpfCnpj')?.touched" class="error-message">
          {{ cpfCnpjLabel }} é obrigatório.
        </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field form-field-4">
        <label for="email">Email <span class="required">*</span></label>
        <input 
          id="email" 
          type="email" 
          pInputText 
          formControlName="email" 
          placeholder="Digite o email"
          [ngClass]="{'invalid-field': clienteForm.get('email')?.invalid && clienteForm.get('email')?.touched}" />
        <small *ngIf="clienteForm.get('email')?.invalid && clienteForm.get('email')?.touched" class="error-message">
          Email é obrigatório e deve ser válido.
        </small>
      </div>

      <div class="form-field form-field-4">
        <label for="telefone">Telefone <span class="required">*</span></label>
        <input 
          id="telefone" 
          type="text" 
          pInputText 
          mask="(00) 00000-0000" 
          formControlName="telefone" 
          placeholder="(00) 00000-0000"
          [ngClass]="{'invalid-field': clienteForm.get('telefone')?.invalid && clienteForm.get('telefone')?.touched}" />
        <small *ngIf="clienteForm.get('telefone')?.invalid && clienteForm.get('telefone')?.touched" class="error-message">
          Telefone é obrigatório.
        </small>
      </div>

      <div class="form-field form-field-4">
        <label for="inscricaoMunicipal">Inscrição Municipal</label>
        <input 
          id="inscricaoMunicipal" 
          type="text" 
          [attr.maxlength]="15" 
          pInputText 
          formControlName="inscricaoMunicipal" 
          placeholder="Digite a inscrição municipal"
          [ngClass]="{'invalid-field': clienteForm.get('inscricaoMunicipal')?.invalid && clienteForm.get('inscricaoMunicipal')?.touched}" />
        <small class="field-hint">Entre 7 e 15 caracteres</small>
        <small *ngIf="clienteForm.get('inscricaoMunicipal')?.invalid && clienteForm.get('inscricaoMunicipal')?.touched" class="error-message">
          Inscrição Municipal deve conter entre 7 e 15 caracteres.
        </small>
      </div>
    </div>
  </fieldset>

  <fieldset class="form-block mt-3">
    <legend class="form-block-legend">Endereço</legend>
    <div class="form-row">
      <div class="form-field form-field-2">
        <label for="tipoLogradouro">Tipo de Logradouro</label>
        <p-dropdown 
          id="tipoLogradouro" 
          [options]="tipoLogradouros" 
          optionLabel="label" 
          optionValue="value"
          formControlName="tipoLogradouro" 
          placeholder="Selecione o tipo"
          [showClear]="true">
        </p-dropdown>
      </div>

      <div class="form-field form-field-6">
        <label for="logradouro">Logradouro <span class="required" *ngIf="isAddressRequired">*</span></label>
        <input 
          id="logradouro" 
          type="text" 
          pInputText 
          formControlName="logradouro" 
          placeholder="Digite o logradouro"
          [ngClass]="{'invalid-field': clienteForm.get('logradouro')?.invalid && clienteForm.get('logradouro')?.touched}" />
        <small *ngIf="clienteForm.get('logradouro')?.invalid && clienteForm.get('logradouro')?.touched" class="error-message">
          Logradouro é obrigatório.
        </small>
      </div>

      <div class="form-field form-field-2">
        <label for="numero">Número <span class="required" *ngIf="isAddressRequired">*</span></label>
        <input 
          id="numero" 
          type="text" 
          pInputText 
          formControlName="numero" 
          placeholder="Nº"
          [ngClass]="{'invalid-field': clienteForm.get('numero')?.invalid && clienteForm.get('numero')?.touched}" />
        <small *ngIf="clienteForm.get('numero')?.invalid && clienteForm.get('numero')?.touched" class="error-message">
          Número é obrigatório.
        </small>
      </div>

      <div class="form-field form-field-2">
        <label for="complemento">Complemento</label>
        <input 
          id="complemento" 
          type="text" 
          pInputText 
          formControlName="complemento" 
          placeholder="Digite o complemento" />
      </div>
    </div>

    <div class="form-row">
      <div class="form-field form-field-4">
        <label for="bairro">Bairro <span class="required" *ngIf="isAddressRequired">*</span></label>
        <input 
          id="bairro" 
          type="text" 
          pInputText 
          formControlName="bairro" 
          placeholder="Digite o bairro"
          [ngClass]="{'invalid-field': clienteForm.get('bairro')?.invalid && clienteForm.get('bairro')?.touched}" />
        <small *ngIf="clienteForm.get('bairro')?.invalid && clienteForm.get('bairro')?.touched" class="error-message">
          Bairro é obrigatório.
        </small>
      </div>

      <div class="form-field form-field-2" *ngIf="showCep">
        <label for="cep">CEP <span class="required">*</span></label>
        <input 
          id="cep" 
          type="text" 
          pInputText 
          formControlName="cep" 
          mask="00000-000" 
          placeholder="00000-000"
          [ngClass]="{'invalid-field': clienteForm.get('cep')?.invalid && clienteForm.get('cep')?.touched}" />
        <small *ngIf="clienteForm.get('cep')?.invalid && clienteForm.get('cep')?.touched" class="error-message">
          CEP é obrigatório.
        </small>
      </div>

      <div class="form-field form-field-2">
        <label for="pais">País <span class="required">*</span></label>
        <p-dropdown
          [options]="paises"
          placeholder="Selecione o País"
          optionLabel="label"
          optionValue="value"
          formControlName="pais"
          id="pais"
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          (onChange)="onChangePais($event.value)"
          [ngClass]="{'invalid-field': clienteForm.get('pais')?.invalid && clienteForm.get('pais')?.touched}">
        </p-dropdown>
        <small *ngIf="clienteForm.get('pais')?.invalid && clienteForm.get('pais')?.touched" class="error-message">
          País é obrigatório.
        </small>
      </div>
    </div>

    <div class="form-row" *ngIf="showUf && showMunicipio">
      <div class="form-field form-field-2">
        <label for="uf">UF <span class="required">*</span></label>
        <p-dropdown
          id="uf"
          [filter]="true"
          filterBy="label"
          [options]="estados"
          optionLabel="label"
          optionValue="value"
          formControlName="uf"
          placeholder="UF"
          [disabled]="!ufEnabled"
          [ngClass]="{'invalid-field': clienteForm.get('uf')?.invalid && clienteForm.get('uf')?.touched}">
        </p-dropdown>
        <small *ngIf="clienteForm.get('uf')?.invalid && clienteForm.get('uf')?.touched" class="error-message">
          UF é obrigatória.
        </small>
      </div>
      
      <div class="form-field form-field-4">
        <label for="municipio">Município <span class="required">*</span></label>
        <p-dropdown
          id="municipio"
          [filter]="true"
          filterBy="label"
          [options]="municipios"
          optionLabel="label"
          optionValue="value"
          formControlName="codigoMunicipio"
          placeholder="Selecione o município"
          [disabled]="!municipioEnabled"
          [ngClass]="{'invalid-field': clienteForm.get('codigoMunicipio')?.invalid && clienteForm.get('codigoMunicipio')?.touched}">
        </p-dropdown>
        <small *ngIf="clienteForm.get('codigoMunicipio')?.invalid && clienteForm.get('codigoMunicipio')?.touched" class="error-message">
          Município é obrigatório.
        </small>
      </div>
    </div>
  </fieldset>

  <div class="form-actions mt-4">
    <p-button type="button" label="Cancelar" icon="pi pi-times" severity="danger" (click)="onCancel()"></p-button>
    <p-button type="submit" label="Salvar" icon="pi pi-check" [disabled]="clienteForm.invalid"></p-button>
  </div>
</form>

